import { formatCanadianPostalCode } from 'helper/common'

// formatCanadianPostalCode inserts the space after 3 characters, so the field
// value is "A1A", "A1A 1", or "A1A 12" until the code is complete ("A1A 1A1").
export const CANADIAN_POSTAL_CODE_PATTERN =
  /^(?:[A-Za-z0-9]{1,3}|[A-Za-z0-9]{3} [A-Za-z0-9]{1,3})$/

export const getZipCodeByCountry = (zip?: string, country?: string) =>
  country === 'CA' ? formatCanadianPostalCode(zip) : zip

export const getCanadianPostalCodeItemProps = (country?: string) =>
  country === 'CA'
    ? {
        getValueFromEvent: (e: { target: { value: string } }) =>
          formatCanadianPostalCode(e.target.value),
        rules: [
          {
            pattern: CANADIAN_POSTAL_CODE_PATTERN,
            validateTrigger: ['onBlur', 'onSubmit']
          }
        ]
      }
    : {}

export const findDuplicateIndices = (addresses) => {
  const seen = new Map()
  const duplicates = new Set()

  addresses.forEach((addr, index) => {
    const country = addr?.country?.trim()?.toLowerCase()
    const street = addr?.street?.trim()?.toLowerCase()
    const city = addr?.city?.trim()?.toLowerCase()
    const state = addr?.state?.trim()?.toLowerCase()
    const zip = addr?.zip_code?.trim()

    if (!street || !city || !state || !zip || !country) return

    const key = `${country}-${street}-${city}-${state}-${zip}`

    if (seen.has(key)) {
      duplicates.add(index)
      duplicates.add(seen.get(key))
    } else {
      seen.set(key, index)
    }
  })

  return duplicates
}
